import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import {AuthService} from "../services/auth.service";

export const AuthGuard: CanActivateFn | CanActivateChildFn = async (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);

    var isUserLoggedIn = await authService.isAuthenticated();

    if(isUserLoggedIn) {
        return true;
    }
    else {
        return router.parseUrl(`sign-in`);
    }
};
